import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Paper,
  Typography,
  Divider,
  Box,
  Container,
  Button,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../../SideBar";

const ReportsDashboard = () => {
  const isLogin = useSelector((state) => state.user.isLogin);
  const userInfo = useSelector((state) => state.user.userInfo);
  const user = isLogin ? JSON.parse(userInfo) : null;
  const [userDetails, setUserDetails] = useState({});
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // Sample list of reports
  const reports = [
    {
      id: 1,
      name: "Customers Gotten Report",
      path: "/dashboardpage/reports/customers-gotten",
    },
    {
      id: 2,
      name: "Events With 150+ Attendees",
      path: "/dashboardpage/reports/events-with-150-attendees",
    },
    {
      id: 3,
      name: "User Engagement Report",
      path: "/dashboardpage/reports/user-engagement",
    },
    { id: 4, name: "Inventory Report", path: "/reports/inventory" },
    { id: 5, name: "User Activity Report", path: "/reports/user-activity" },
    { id: 6, name: "Financial Report", path: "/reports/financial" },
  ];

  // Handle report click to navigate
  const handleReportClick = (path) => {
    navigate(path);
  };

  return (
    <section className="home-after-login bg-white">
      <div className="container">
        <Row className="Report-container px-0">
          <Col sm={3} className="stgs_sbar mt-2 mx-0">
            <Sidebar />
          </Col>
          <Col sm={9} className="stgs_content mt-2">
            <Box
              sx={{
                p: { xs: 2, md: 4 },
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                minHeight: "80vh",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  sx={{
                    minWidth: "auto",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  ← Back
                </Button>
                <Typography
                  variant="h5"
                  component="h5"
                  gutterBottom
                  sx={{ fontWeight: "bold", color: "text.primary" }}
                >
                  Reports Dashboard
                </Typography>
              </Box>
              {/* <Divider sx={{ mb: 3, borderColor: "grey.300" }} /> */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid",
                    borderColor: "grey.200",
                  }}
                >
                  <List>
                    {reports.map((report) => (
                      <ListItem
                        key={report.id}
                        disablePadding
                        sx={{
                          "&:not(:last-child)": {
                            borderBottom: "1px solid",
                            borderColor: "grey.200",
                          },
                        }}
                      >
                        <ListItemButton
                          selected={location.pathname === report.path}
                          onClick={() => handleReportClick(report.path)}
                          sx={{
                            py: 2,
                            px: 3,
                            "&:hover": {
                              bgcolor: `grey.100`,
                              color: "primary.main",
                            },
                            "&.Mui-selected": {
                              bgcolor: "primary.main",
                              color: "white",
                              "& .MuiListItemText-primary": {
                                color: "white",
                                fontWeight: 500,
                              },
                              "&:hover": {
                                bgcolor: "primary.dark",
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary={report.name}
                            primaryTypographyProps={{
                              fontSize: "1.1rem",
                              fontWeight: 400,
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </motion.div>
            </Box>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ReportsDashboard;
